import { render, staticRenderFns } from "./FightButtons.vue?vue&type=template&id=23017e82&scoped=true"
import script from "./FightButtons.vue?vue&type=script&lang=js"
export * from "./FightButtons.vue?vue&type=script&lang=js"
import style0 from "./FightButtons.vue?vue&type=style&index=0&id=23017e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23017e82",
  null
  
)

export default component.exports